import { ChangeDetectionStrategy, Component, ElementRef, HostListener, inject } from '@angular/core';

import { BaasToastMessage } from '../baas-toast-message/baas-toast-message';
import { BaasToastMessageService } from '../baas-toast-message-service';

@Component({
    selector: 'baas-toast-messages',
    templateUrl: './baas-toast-messages.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [BaasToastMessage]
})
export class BaasToastMessages {
    readonly #element = inject(ElementRef);
    readonly #toastService = inject(BaasToastMessageService);

    protected readonly messages = this.#toastService.messages;

    @HostListener('document:fullscreenchange', ['$event'])
    onFullscreenChange(e: Event) {
        if (document.fullscreenElement) {
            document.fullscreenElement.appendChild(this.#element.nativeElement);
        } else {
            this.#element.nativeElement.parentElement.appendChild(this.#element.nativeElement);
        }
    }
}
